import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { notify } from '../utils/ToastUtils';

const defaultInitialState = {
    Salutation: "",
    Full_Name: "",
    Gender: "",
    Nationality: "",
    FathersName: "",
    MaritalStatus: "",
    SpouseName: "",
    BloodGroup: "",
    PhysicallyChallenged: "",
    DateOfBirth: "",
    Bank_Name: "",
    BankBranch: "",
    IFCCode: "",
    BankAccountNumber: "",
    NameInBank: "",
    PFNo: "",
    FreshEmployementForPf: "",
    PAN_Number: "",
    AADHAAR_Number: "",
    NamePerAadhaar: "",
    GenderPerAadhaar: "",
    Date_of_Birth_as_per_Aadhaar: "",
    address: "",
    PersonalEmail: "",
    MobileNumber: "",
    EmergencyContact: "",
    RelationshipOfEmergency: "",
    Pan_Card_Upload: "",
    Aadhaar_Card_Upload: "",
    Upload_Passport_Size_photo_Copy: "",
    UAN: "",
    Resume_Upload: "",
    Salary_Slips_Upload: "",
    Form_16_Upload: "",
    ESIC_Card_Upload: "",
    Tenth_Marksheet_Upload: "",
    Twelth_Marksheet_Upload: "",
    UG_Provisional_Or_Degree_Certificate: "",
    PG_Provisional_Or_Degree_Certificate: "",
    RollNo: "",
    pincode: "",
    ugDegree1: '', ugdepartment1: '', ugcollegeName1: '', ugugPassed1: '',
    ugDegree2: '', ugdepartment2: '', ugcollegeName2: '', ugugPassed2: '',
    ugDegree3: '', ugdepartment3: '', ugcollegeName3: '', ugugPassed3: '',
    pgDegree1: '', pgdepartment1: '', pgcollegeName1: '', pgPgPassed1: '',
    pgDegree2: '', pgdepartment2: '', pgcollegeName2: '', pgPgPassed2: '',
    pgDegree3: '', pgdepartment3: '', pgcollegeName3: '', pgPgPassed3: '',
    Designation1: '', From1: '', To1: '',
    Designation2: '', From2: '', To2: '',
    Designation3: '', From3: '', To3: '',
    Designation4: '', From4: '', To4: '',
    Designation5: '', From5: '', To5: '',
    CANDIDATE_COUNTRY: 'INDIA', // overriden in hook if US
    SSN: '',
    PassportNumber: '',
    holdPassport: ''
};

const pdfinitialState = {
    Pan_Card_Upload: "",
    Aadhaar_Card_Upload: "",
    Tenth_Marksheet_Upload: "",
    Twelth_Marksheet_Upload: "",
    UG_Provisional_Or_Degree_Certificate: "",
    PG_Provisional_Or_Degree_Certificate: ""
};

export const useOnboarding = ({ isUS, fieldsToCheck, type }) => {
    const params = useParams();
    const nav = useNavigate();
    
    const [isVaild, setisVaild] = useState(null);
    const [isInitializing, setIsInitializing] = useState(true);
    const [checked, setChecked] = useState(false);
    const [modal, setModal] = useState(false);
    const [internId, setInternId] = useState("");
    const [isSuccess, setIsSuccess] = useState(false);
    const [candidateType, setCandidateType] = useState(type || "");
    const [candidateName, setCandidateName] = useState("");
    
    const [emptyFields, setEmptyFields] = useState([]);
    const [formError, setFormError] = useState({ general: "", validation: {} });
    
    const [dynamicRequiredDocs, setDynamicRequiredDocs] = useState([]);
    const [dynamicDocFiles, setDynamicDocFiles] = useState({});
    const [dynamicCustomFields, setDynamicCustomFields] = useState([]);
    const [dynamicCustomValues, setDynamicCustomValues] = useState({});
    const [dynamicCustomFiles, setDynamicCustomFiles] = useState({});
    
    const [workDate, setWorkDate] = useState([{ min: "" }, { min: "" }, { min: "" }, { min: "" }, { min: "" }]);
    
    const [state, setState] = useState({ ...defaultInitialState, CANDIDATE_COUNTRY: isUS ? 'US' : 'INDIA' });
    const [PdfError, setPdfError] = useState(pdfinitialState);
    const [ImgError, setImgError] = useState("");
    const [loading, setLoading] = useState(false);
    
    const [ug, setUg] = useState([{ Degree: '', department: '', collegeName: '', UG_Provisional_Or_Degree_Certificate: '', ugPassed: '' }]);
    const [pg, setPg] = useState([{ Degree: '', department: '', collegeName: '', PG_Provisional_Or_Degree_Certificate: '', PgPassed: '' }]);
    const [work, setWork] = useState([]);
    
    const [diaplayWork, setDisplayWork] = useState(false);
    const [diaplayPassport, setDisplayPassport] = useState(false);

    useEffect(() => {
        tokenCheck();
    }, []);

    const modalOpen = () => {
        if (checked === false) setModal(true);
    };

    const handleCheckBoxChange = (event) => {
        setChecked(event.target.checked);
    };

    function handleChange(evt) {
        const value = evt.target.value;
        setState(prev => ({
            ...prev,
            [evt.target.name]: value
        }));
        
        if (evt.target.name === "FreshEmployementForPf") {
            if (value === "No") {
                setDisplayWork(true);
                setWork([{ Designation: '', From: '', To: '', Experience_Certificate: '' }]);
            } else {
                setDisplayWork(false);
                setWork([]);
            }
        }
        
        if (evt.target.name === "holdPassport") {
            setDisplayPassport(value === "Yes" ? 'yes' : 'No');
        }
        
        setEmptyFields(prev => prev.filter(field => field !== evt.target.name));
        setFormError(prev => ({ ...prev, general: "" }));
    }

    function handleImageChange(evt) {
        var files = evt.target.files || evt.dataTransfer.files;
        if (!files.length) return;
        if (evt.target.files[0].type.startsWith('image/')) {
            setImgError("");
        } else {
            setImgError("Only image files (JPG, PNG) are allowed");
        }
        setState(prev => ({
            ...prev,
            [evt.target.name]: evt.target.files[0]
        }));
        setEmptyFields(prev => prev.filter(field => field !== evt.target.name));
        setFormError(prev => ({ ...prev, general: "" }));
    }

    function handlePdfChange(evt) {
        var files = evt.target.files || evt.dataTransfer.files;
        if (!files.length) return;
        if (evt.target.files[0].type !== 'application/pdf') {
            setPdfError(prev => ({
                ...prev,
                [evt.target.name]: "Only PDF files are allowed"
            }));
        } else {
            setPdfError(prev => ({
                ...prev,
                [evt.target.name]: ""
            }));
        }
        setState(prev => ({
            ...prev,
            [evt.target.name]: evt.target.files[0]
        }));
        setEmptyFields(prev => prev.filter(field => field !== evt.target.name));
        setFormError(prev => ({ ...prev, general: "" }));
    }

    function handleDynamicFileChange(evt, fieldName, isCustom, linkedFile) {
        var files = evt.target.files || evt.dataTransfer.files;
        if (!files.length) return;
        
        const keyName = isCustom ? `dynamic_custom_file_${fieldName}` : `dynamic_doc_${fieldName}`;
        const file = evt.target.files[0];

        if (!isCustom) {
            let expectedFormat = null;
            if (linkedFile && typeof linkedFile === 'string' && linkedFile.includes('.')) {
                expectedFormat = linkedFile.split('.').pop().toLowerCase();
            }

            const fileFormat = file.name.split('.').pop().toLowerCase();

            if (expectedFormat && fileFormat !== expectedFormat) {
                setFormError(prev => ({
                    ...prev,
                    [keyName]: `Only .${expectedFormat} files are allowed`
                }));
                evt.target.value = null;
                return;
            } else if (!expectedFormat && file.type !== 'application/pdf') {
                setFormError(prev => ({
                    ...prev,
                    [keyName]: "Only PDF files are allowed"
                }));
                evt.target.value = null;
                return;
            }
        }

        setFormError(prev => ({
            ...prev,
            [keyName]: ""
        }));

        if (isCustom) {
            setDynamicCustomFiles(prev => ({
                ...prev,
                [keyName]: file
            }));
        } else {
            setDynamicDocFiles(prev => ({
                ...prev,
                [keyName]: file
            }));
        }

        setEmptyFields(prev => prev.filter(field => field !== keyName));
        setFormError(prev => ({ ...prev, general: "" }));
    }

    function handleDynamicFieldChange(evt, fieldName) {
        setDynamicCustomValues(prev => ({
            ...prev,
            [fieldName]: evt.target.value
        }));
        setEmptyFields(prev => prev.filter(field => field !== `dynamic_custom_${fieldName}`));
        setFormError(prev => ({ ...prev, general: "" }));
    }

    const addUgForm = () => {
        setUg([...ug, { Degree: '', department: '', collegeName: '', UG_Provisional_Or_Degree_Certificate: '', ugPassed: '' }]);
    };
    
    const addPgForm = () => {
        setPg([...pg, { Degree: '', department: '', collegeName: '', PG_Provisional_Or_Degree_Certificate: '', PgPassed: '' }]);
    };

    const addWorkForm = () => {
        setWork([...work, { Designation: '', From: '', To: '', Experience_Certificate: '' }]);
        setWorkDate([...workDate, { min: "" }]);
    };

    const deleteUgForm = (index) => {
        if (ug.length > 1) {
            const updatedUg = [...ug];
            updatedUg.splice(index, 1);
            setUg(updatedUg);
        }
    };
    
    const deletePgForm = (index) => {
        const updatedPg = [...pg];
        updatedPg.splice(index, 1);
        setPg(updatedPg);
    };

    const deleteWorkForm = (index) => {
        if (work.length > 1) {
            const updatedWork = [...work];
            updatedWork.splice(index, 1);
            setWork(updatedWork);
            const updateworkdate = [...workDate];
            updateworkdate.splice(index, 1);
            setWorkDate(updateworkdate);
        }
    };

    const handleUgFormChange = (index, event) => {
        const updatedUg = [...ug];
        if (event.target.name === 'UG_Provisional_Or_Degree_Certificate') {
            if (event.target.files[0]?.type !== 'application/pdf') {
                setPdfError(prev => ({ ...prev, ["UG_Provisional_Or_Degree_Certificate" + (index + 1)]: "Only PDF files are allowed" }));
                event.target.value = "";
                updatedUg[index][event.target.name] = "";
            } else {
                setPdfError(prev => ({ ...prev, ["UG_Provisional_Or_Degree_Certificate" + (index + 1)]: "" }));
                updatedUg[index][event.target.name] = event.target.files[0];
            }
        } else {
            updatedUg[index][event.target.name] = event.target.value;
        }
        setUg(updatedUg);
        setEmptyFields(prev => prev.filter(field => field !== (`ug${event.target.name}${index + 1}`)));
        setFormError(prev => ({ ...prev, general: "" }));
    };

    const handlePgFormChange = (index, event) => {
        const updatedPg = [...pg];
        if (event.target.name === 'PG_Provisional_Or_Degree_Certificate') {
            if (event.target.files[0]?.type !== 'application/pdf') {
                setPdfError(prev => ({ ...prev, ["PG_Provisional_Or_Degree_Certificate" + (index + 1)]: "Only PDF files are allowed" }));
                event.target.value = "";
                updatedPg[index][event.target.name] = "";
            } else {
                setPdfError(prev => ({ ...prev, ["PG_Provisional_Or_Degree_Certificate" + (index + 1)]: "" }));
                updatedPg[index][event.target.name] = event.target.files[0];
            }
        } else {
            updatedPg[index][event.target.name] = event.target.value;
        }
        setPg(updatedPg);
        setEmptyFields(prev => prev.filter(field => field !== (`pg${event.target.name}${index + 1}`)));
        setFormError(prev => ({ ...prev, general: "" }));
    };

    const handleWorkFormChange = (index, event) => {
        const updatedWork = [...work];
        if (event.target.name === 'Experience_Certificate') {
            updatedWork[index][event.target.name] = event.target.files[0];
        } else if (event.target.name === "From") {
            const data = [...workDate];
            data[index].min = event.target.value;
            setWorkDate(data);
            updatedWork[index][event.target.name] = event.target.value;
            updatedWork[index]["To"] = "";
        } else {
            updatedWork[index][event.target.name] = event.target.value;
        }
        setWork(updatedWork);
        setEmptyFields(prev => prev.filter(field => field !== (event.target.name + (index + 1))));
        setFormError(prev => ({ ...prev, general: "" }));
    };

    const tokenCheck = async () => {
        setIsInitializing(true);
        try {
            var data = await axios.post(`${process.env.REACT_APP_BASE_URL}/action/onboardingTokenCheck`, { token: params.token });
            if (data.data.message == "invalid token") {
                // nav("/login");
                return;
            }
            
            const fetchedInternId = data?.data[0]?.INTERN_ID;
            setInternId(fetchedInternId);
            const _candidateType = data?.data[0]?.TYPE;
            setCandidateType(_candidateType);
            if (data?.data[0]?.NAME) {
                setCandidateName(data.data[0].NAME);
            }
            
            // Check if already submitted
            let _isSuccess = false;
            try {
                var submitData = await axios.post(`${process.env.REACT_APP_BASE_URL}/action/getOnboard`, { "intern_id": fetchedInternId });
                var info = submitData?.data?.filter((ele) => ele.link_id == params.token);
                if (info?.length > 0) {
                    setIsSuccess(true);
                    _isSuccess = true;
                }
            } catch (error) {
                console.log(error);
            }
            
            if (!_isSuccess) {
                // Fetch role config to determine dynamic required documents
                try {
                    const roleConfigRes = await axios.get(`${process.env.REACT_APP_BASE_URL}/action/getRoleConfig`);
                    const configForRole = roleConfigRes?.data?.find(c => c?.ROLE_NAME === _candidateType);
                    if (configForRole && configForRole?.REQUIRED_DOCUMENTS_JSON) {
                        const reqDocs = configForRole?.REQUIRED_DOCUMENTS_JSON;
                        const mappedDocs = reqDocs?.map(d => typeof d === 'string' ? { fieldName: d, linkedFile: null } : d);
                        setDynamicRequiredDocs(mappedDocs);
                        
                        let initialDocFiles = {};
                        let initialDocErrors = {};
                        mappedDocs.forEach(doc => {
                            initialDocFiles[`dynamic_doc_${doc.fieldName}`] = "";
                            initialDocErrors[`dynamic_doc_${doc.fieldName}`] = "";
                        });
                        setDynamicDocFiles(initialDocFiles);
                        setFormError(prev => ({...prev, ...initialDocErrors}));
                    }
                    
                    if (configForRole && configForRole?.CUSTOM_FIELDS_JSON) {
                        const custFields = configForRole?.CUSTOM_FIELDS_JSON;
                        const mappedFields = custFields?.map(f => typeof f === 'string' ? { fieldName: f, type: 'Text', required: true } : f);
                        setDynamicCustomFields(mappedFields);
                        
                        let initialCustomVals = {};
                        let initialCustomFiles = {};
                        let initialCustomFileErrors = {};
                        mappedFields?.forEach(field => {
                            if (field.type === 'File') {
                                initialCustomFiles[`dynamic_custom_file_${field.fieldName}`] = "";
                                initialCustomFileErrors[`dynamic_custom_file_${field.fieldName}`] = "";
                            } else {
                                initialCustomVals[`dynamic_field_${field.fieldName}`] = "";
                            }
                        });
                        setDynamicCustomValues(initialCustomVals);
                        setDynamicCustomFiles(initialCustomFiles);
                        setFormError(prev => ({...prev, ...initialCustomFileErrors}));
                    }
                } catch (e) {
                    console.error("Failed to fetch role config:", e);
                }
            }
            
            setisVaild(data?.data?.message);
        } catch (error) {
            console.error(error);
            setisVaild(false);
        } finally {
            setIsInitializing(false);
        }
    };

    const isSubmitted = async () => {
        try {
            var data = await axios.post(`${process.env.REACT_APP_BASE_URL}/action/getOnboard`, { "intern_id": internId });
            var info = data?.data?.filter((ele) => ele.link_id == params.token);
            if (info?.length > 0) setIsSuccess(true);
        } catch (error) {
            console.log(error);
        }
    };

    const findEmptyFields = (obj) => {
        if (!obj || typeof obj !== 'object') return [];
        const _emptyFields = [];
        for (const key in obj) {
            if (candidateType !== 'Employee' && (key === 'UG_Provisional_Or_Degree_Certificate' || key === 'ugPassed')) continue;
            if (obj.hasOwnProperty(key) && (obj[key] === "" || obj[key] === undefined)) {
                _emptyFields.push(key);
            }
        }
        return _emptyFields;
    };

    const handleSubmit = async () => {
        let currentFieldsToCheck = [...fieldsToCheck];
        
        state['intern_id'] = internId;
        state['link_id'] = params.token;
        
        if (candidateType === "Intern") {
            currentFieldsToCheck.push('RollNo');
        }
        
        if (candidateType === "Employee" && !isUS) {
            let empFields = ['PFNo'];
            if (state.FreshEmployementForPf === "Yes") {
                empFields = empFields.filter(f => f !== 'PFNo');
            }
            currentFieldsToCheck.push(...empFields);
        }

        if (diaplayPassport === "yes") {
            currentFieldsToCheck.push('PassportNumber');
        }
        
        let _emptyFields = currentFieldsToCheck.filter(fieldName => !state[fieldName]);
        
        const pdfFilter = Object.keys(PdfError).filter(key => PdfError[key] !== "");
        
        var worktemp = work.map(findEmptyFields);
        const mergedwork = worktemp.reduce((result, subArray, index) => {
            subArray.forEach((item) => {
                result.push(`${item}${index + 1}`);
            });
            return result;
        }, []);
        _emptyFields = [..._emptyFields, ...mergedwork];

        var ugtemp = ug.map(findEmptyFields);
        const mergedug = ugtemp.reduce((result, subArray, index) => {
            subArray.forEach((item) => {
                result.push(`ug${item}${index + 1}`);
            });
            return result;
        }, []);
        _emptyFields = [..._emptyFields, ...mergedug];
        
        var pgtemp = pg.map((item) => {
            const emptyKeys = findEmptyFields(item);
            if (emptyKeys.length === Object.keys(item).length) return [];
            return emptyKeys;
        });
        const mergedpg = pgtemp.reduce((result, subArray, index) => {
            subArray.forEach((item) => {
                result.push(`pg${item}${index + 1}`);
            });
            return result;
        }, []);
        _emptyFields = [..._emptyFields, ...mergedpg];

        dynamicRequiredDocs.forEach(doc => {
            const keyName = `dynamic_doc_${doc.fieldName}`;
            if (!dynamicDocFiles[keyName]) {
                _emptyFields.push(keyName);
            }
        });
        
        dynamicCustomFields.forEach(field => {
            if (field.required) {
                if (field.type === 'File') {
                    const keyName = `dynamic_custom_file_${field.fieldName}`;
                    if (!dynamicCustomFiles[keyName]) {
                        _emptyFields.push(keyName);
                    }
                } else {
                    const keyName = `dynamic_field_${field.fieldName}`;
                    if (!dynamicCustomValues[keyName]) {
                        _emptyFields.push(keyName);
                    }
                }
            }
        });
        
        if (_emptyFields.length === 0) {
            setEmptyFields([]);
            if (pdfFilter.length !== 0 || ImgError !== "") {
                notify.error("Please Check The File Format");
                return;
            }
            if (checked) {
                var requestData = { ...state };
                var merged = {};
                
                ug.forEach((item, i) => {
                    for (const key in item) {
                        merged[`ug${key}${i + 1}`] = item[key];
                    }
                });
                requestData = { ...requestData, ...merged };
                merged = {};
                
                pg.forEach((item, i) => {
                    for (const key in item) {
                        merged[`pg${key}${i + 1}`] = item[key];
                    }
                });
                requestData = { ...requestData, ...merged };
                merged = {};
                
                work.forEach((item, i) => {
                    for (const key in item) {
                        merged[`${key}${i + 1}`] = item[key];
                    }
                });
                requestData = { ...requestData, ...merged, dynamic_fields: JSON.stringify(dynamicCustomValues) };
                
                try {
                    const formData = new FormData();
                    if (!isUS) {
                        formData.append('pancard', state.Pan_Card_Upload);
                        formData.append('aadharcard', state.Aadhaar_Card_Upload);
                    }
                    formData.append('photo', state.Upload_Passport_Size_photo_Copy);
                    if (state.ciia) formData.append('ciia', state.ciia);
                    
                    if (state.Resume_Upload) formData.append('resume', state.Resume_Upload);
                    if (state.Salary_Slips_Upload) formData.append('salaryslips', state.Salary_Slips_Upload);
                    if (state.Form_16_Upload) formData.append('form16', state.Form_16_Upload);
                    if (state.ESIC_Card_Upload) formData.append('esiccard', state.ESIC_Card_Upload);
                    if (state.Tenth_Marksheet_Upload) formData.append('Tenth', state.Tenth_Marksheet_Upload);
                    if (state.Twelth_Marksheet_Upload) formData.append('Twelth', state.Twelth_Marksheet_Upload);

                    for (var i = 1; i <= 3; i++) {
                        formData.append('ug' + i, requestData?.[`ugUG_Provisional_Or_Degree_Certificate${i}`]);
                        formData.append('pg' + i, requestData?.[`pgPG_Provisional_Or_Degree_Certificate${i}`]);
                    }
                    for (var i = 1; i <= 5; i++) {
                        formData.append('work' + i, requestData?.[`Experience_Certificate${i}`]);
                    }

                    dynamicRequiredDocs.forEach(doc => {
                        if (dynamicDocFiles[`dynamic_doc_${doc.fieldName}`]) {
                            formData.append(`dynamic_doc_${doc.fieldName}`, dynamicDocFiles[`dynamic_doc_${doc.fieldName}`]);
                        }
                    });
                    
                    dynamicCustomFields.forEach(field => {
                        if (field.type === 'File' && dynamicCustomFiles[`dynamic_custom_file_${field.fieldName}`]) {
                            formData.append(`dynamic_custom_file_${field.fieldName}`, dynamicCustomFiles[`dynamic_custom_file_${field.fieldName}`]);
                        }
                    });

                    formData.append('link_id', params.token);
                    
                    setLoading(true);
                    await axios.post(`${process.env.REACT_APP_BASE_URL}/action/submitOnboard`, requestData);
                    
                    try {
                        await axios.post(`${process.env.REACT_APP_BASE_URL}/action/submitOnboardFiles`, formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            }
                        });
                    } catch (error) {
                        console.log(error);
                    }
                    
                    setFormError(prev => ({ ...prev, general: "" }));
                    setTimeout(() => {
                        notify.success("OnBoarding Submitted successfully");
                        setLoading(false);
                        setIsSuccess(true);
                    }, 500);
                } catch (error) {
                    console.log(error);
                    setLoading(false);
                }
            } else {
                setFormError(prev => ({ ...prev, general: "Please check the checkbox" }));
            }
        } else {
            setEmptyFields(_emptyFields);
            setFormError(prev => ({ ...prev, general: "Please fill the mandatory fields highlighted below." }));
            setTimeout(() => {
                const firstErrorField = document.querySelector('.border-red-500, .Mui-error');
                if (firstErrorField) {
                    firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 100);
        }
    };

    return {
        isInitializing,
        isVaild,
        isSuccess,
        type: candidateType,
        candidateName,
        checked,
        setChecked,
        modal,
        setModal,
        modalOpen,
        handleCheckBoxChange,
        state,
        handleChange,
        handleImageChange,
        handlePdfChange,
        handleDynamicFileChange,
        handleDynamicFieldChange,
        emptyFields,
        setEmptyFields,
        formError,
        setFormError,
        PdfError,
        ImgError,
        displayWork: diaplayWork,
        diaplayPassport,
        ug,
        addUgForm,
        deleteUgForm,
        handleUgFormChange,
        pg,
        addPgForm,
        deletePgForm,
        handlePgFormChange,
        work,
        addWorkForm,
        deleteWorkForm,
        handleWorkFormChange,
        workDate,
        handleSubmit,
        dynamicRequiredDocs,
        dynamicCustomFields,
        dynamicCustomValues,
        dynamicDocFiles,
        dynamicCustomFiles,
        loading
    };
};
